import { ReactNode } from "react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Lock } from "lucide-react";
import { useNotesMarketStatus } from "@/hooks/useNotesMarketStatus";
import NotesMarketComingSoon from "@/components/notes/NotesMarketComingSoon";

/**
 * Blocks Notes Market trading surfaces (browse / buy / list / subscribe) with a
 * "Coming Soon" state while `notes_market_live` is off.
 */
export default function NotesMarketGate({ children, source }: { children: ReactNode; source?: string }) {
  const { locked, loading } = useNotesMarketStatus();
  if (loading) return null;
  if (locked) {
    return (
      <div className="p-4 sm:p-6">
        <NotesMarketComingSoon source={source ?? "app_notes_market"} />
      </div>
    );
  }
  return <>{children}</>;
}

/** Read-only pages (My Notes, history) keep working but show this notice. */
export function NotesMarketLockedNotice({ className }: { className?: string }) {
  const { locked } = useNotesMarketStatus();
  if (!locked) return null;
  return (
    <Alert className={className}>
      <Lock className="h-4 w-4" />
      <AlertTitle>Notes Market is launching soon</AlertTitle>
      <AlertDescription>
        You can review your notes here, but buying, listing and subscriptions stay locked until the market opens.
      </AlertDescription>
    </Alert>
  );
}
